/* template */
<template><div class="finish"><span class="text">{{ $t('personal.noMoreData') }}</span></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m5561e09b"}'>
.finish
  width 600rpx
  margin 0 auto
  padding 40rpx 0
.text
  opacity 0.56
  font-size 24rpx
  color #666666
  text-align center
  display block
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "../../../node_modules/@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentSrcMode = "wx"

import { createComponent } from '@mpxjs/core'
createComponent({
  name: 'finish',
})


  const currentOption = global.currentOption
  export default processOption(
    currentOption,
    "component",
    "",
    "finish5561e09b",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
